import { render, staticRenderFns } from "./SetupStep1.vue?vue&type=template&id=cbca31ea"
import script from "./SetupStep1.vue?vue&type=script&lang=js"
export * from "./SetupStep1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports